import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { page = 1, limit = 20, status, userId, search } = payload || {}
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_WITHDRAWALS, {
      queryParams: {
        page: 1,
        limit: 2000,
        status,
        userId
      }
    })
  },

  parse(raw = {}) {
    if (!raw.success) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch withdrawals',
        data: null,
      }
    }

    const withdrawals = raw.data?.data || []
    const pagination = raw.data?.pagination || {}

    const formattedWithdrawals = withdrawals.map(w => ({
      id: w.id || w._id,
      amount: w.amount,
      currency: w.currency || 'XOF',
      status: w.status, // pending / approved / rejected / completed
      type: w.type, // bank / mobile_money / crypto
      method: w.method,
      accountDetails: w.accountDetails,
      createdAt: w.createdAt,
      updatedAt: w.updatedAt,
      user: w.user || { name: 'Utilisateur', email: '-' }
    }))

    let finalData = formattedWithdrawals
    // === Recherche textuelle locale ===
    const searchTerm = (payload?.search || '').toString().trim().toLowerCase()
    if (searchTerm) {
      finalData = finalData.filter(el => {
        return Object.values(el).some(val => 
          val && typeof val !== 'object' && String(val).toLowerCase().includes(searchTerm)
        )
      })
    }

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      finalData = [...finalData].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') return valA.localeCompare(valB) * order
        if (typeof valA === 'number' && typeof valB === 'number') return (valA - valB) * order
        return 0
      })
    }

    // === Pagination locale ===
    const { page = 0, limit = 20 } = payload || {}
    const paginated = finalData.slice(page * limit, (page + 1) * limit)

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: searchTerm ? finalData.length : (pagination.total || formattedWithdrawals.length),
        result: paginated,
      },
    }
  },
}
